import React, { Component } from 'react';
import Hello from '../component/Hello';
import { inject } from 'mobx-react';
import { withRouter,Link } from 'react-router-dom';
import { Button, Intent, Spinner } from '@blueprintjs/core';
import cookie from '../../src/cookiecut.png';

@withRouter
@inject("store")
export default class Entrance extends Component
{

    introduct(){
        window.localStorage.setItem("firstenter","1");
        this.forceUpdate();
    }
    render()
    {
        return <div className="introduce">
        <div className ="introstart">
       <img src={cookie} className="cookiepicture" alt="cookie" />
       <div className ="introtext">这是小说研究所的练习APP,面向需要练习的初学者<br/><br/>
       里面有小故事、文笔、套路、结构方面的种种具体练习。<br/><br/>
       可以选择你喜欢的,想要成长的方向进行练习（并不需要按顺序，全部练习）
       <br/><br/>
           练习之前，请确定你使用过小说研究所的向导APP，或看过橙色海写作教程(至少看完概述)，或已经有过一定的写作经验。
           <br/>
           如果没有，请从下列按钮中获得向导或教程。)
           
           </div></div>

           <div className = "asktext">请问<br/>你需要向导或教程吗？</div>
          <div className="buttonbox">
          <a href="https://zhuanlan.zhihu.com/p/336226910" title="链接到向导App" target="_APP"><Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.props.store.whynowrite= "nothing"}  >想下载向导App</Button></a><br/>
          <a href="https://zhuanlan.zhihu.com/p/70963887" title="链接到写作教程" target="_course"><Button icon="arrow-right" className="Button" minimal={true}   >想看看写作教程</Button></a><br/>
           <Link to="/"><Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.introduct()} >不用了，开始练习吧！</Button></Link>
           <br/>
           
          </div>

       </div>;
    }
} 